export const transactionTypes = ["payin", "payout", "withdraw", "cashin"];

export const rawPairs = [
  ["rub_card_number", "RUB Card"],
  ["rub_fps", "RUB FPS"],
  ["bol_bank_transfer", "BOL Bank Transfer"],
  ["bol_qr_code", "BOL QR Code"],
  ["ven_pago_movil", "VEN Pago Movil"],
  ["ven_qr_code", "VEN QR Code"],
  ["ven_account_number", "VEN Account Number"],
  ["ecu_account_number", "ECU Account Number"],
  ["ecu_phone_number", "ECU Phone Number"],
  ["krw_bank_transfer", "KRW Bank Transfer"],
  ["krw_kakao_pay", "KRW Kakao Pay"],
  ["rub_mob_com", "RUB Mobile"],
  ["rub_transgran_phone", "TS Phone"],
  ["rub_transgran_card", "TS Card"],
  ["ars_mercado_pago", "ARS Mercado Pago"],
  ["ars_lemon_cash", "ARS Lemon Cash"],
  ["inr_upi_intent", "INR UPI Intent"],
  ["bdt_bkash", "BDT bKash"],
  ["bdt_nagad", "BDT Nagad"],
  ["RUB", "Rubles"],
  ["KRW", "Won"],
  ["SM", "Somoni"],
  ["INR", "Rupee"],
  ["ARS", "Peso"],
  ["KZT", "Tenge"],
  ["BOL", "Boliviano"],
  ["VES", "Bolivar"],
  ["PEN", "Sol"],
  ["BDT", "Taka"],
  ["UZS", "Sum"],
  ["AZN", "Manat"],
  ["KGS", "Som"],
  ["IDR", "Rupiah"],
  ["PKR", "Rupee"],
  ["TRY", "Lira"],
  ["VND", "Dong"],
  ["PHP", "Peso"],
  ["THB", "Thai baht"],
  ["CAD", "Canadian dollar"],
];
export const symbols: Record<string, string> = {
  RUB: "₽",
  KRW: "₩",
  SM: "ЅМ",
  INR: "₹",
  ARS: "$",
  KZT: "₸",
  BOL: "b$",
  VES: "Bs",
  PEN: "S",
  BDT: "৳",
  UZS: "soʻm",
  USDT: "USDT",
  AZN: "₼",
  KGS: "⃀",
  PHP: "₱",
  VND: "₫",
  TRY: "₺",
  PKR: "Rs",
  IDR: "Rp",
  THB: "฿",
  CAD: "C$",
};
export const currencyMeta: Record<
  string,
  {
    label: string;
    img: string;
  }
> = {
  INR: { label: "Rupee", img: "/images/india.png" },
  KRW: { label: "Won", img: "/images/sk.png" },
  SM: { label: "Somoni", img: "/images/tj.png" },
  RUB: { label: "Rubles", img: "/images/rus.png" },
  ARS: { label: "Peso", img: "/images/arg.png" },
  KZT: { label: "Tenge", img: "/images/kz.png" },
  UZS: { label: "Sum", img: "/images/uzs.png" },
  BDT: { label: "Taka", img: "/images/BDT.png" },
  PEN: { label: "Sol", img: "/images/PEN.png" },
  VES: { label: "Bolivar", img: "/images/VES.png" },
  BOL: { label: "Boliviano", img: "/images/BOL.png" },
  USDT: { label: "USDT", img: "/images/USDT.png" },
  AZN: { label: "Manat", img: "/images/AZN.png" },
  KGS: { label: "Som", img: "/images/KGS.png" },
  PHP: { label: "Peso", img: "/images/PHP.png" },
  VND: { label: "Dong", img: "/images/VND.png" },
  TRY: { label: "Lira", img: "/images/TRY.png" },
  PKR: { label: "Rupee", img: "/images/PKR.png" },
  IDR: { label: "Rupiah", img: "/images/IDR.png" },
  THB: { label: "Thai baht", img: "/images/THB.png" },
  CAD: { label: "Canadian dollar", img: "/images/CAD.png" },
};

export const dictionary = Object.fromEntries(rawPairs);
export const reverseDictionary = Object.fromEntries(
  rawPairs.map(([k, v]) => [v, k]),
);
export const translate = (val: any) => dictionary[val] || val;
export const reverseTranslate = (val: any) => reverseDictionary[val] || val;
